import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser } from '../../user/user.interface';

export interface UserState {
  currentUser: IUser | null;
}

const initialState: UserState = {
  currentUser: null
};

export const userSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<IUser | null>) => {
      state.currentUser = action.payload;
    },
    resetCurrentUser: (state) => {
      state.currentUser = null;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setCurrentUser, resetCurrentUser } = userSlice.actions;

export default userSlice.reducer;
